import { IconButton, MenuButton, MenuButtonProps, forwardRef } from '@chakra-ui/react'
import { MdMoreHoriz as MoreIcon } from 'react-icons/md'

export const ActionMenuIconButton = forwardRef<MenuButtonProps, 'button'>(
  function ActionMenuIconButton(props, ref) {
    return <MenuButton ref={ref} as={IconButton} icon={<MoreIcon />} size="sm" {...props} />
  }
)
